import css from '@styled-system/css';
import variant from '@styled-system/variant';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

const HALF_DRAWER_TOP = 50;

themeStyles.addBaseStyles('DrawerContainer')(
  css({
    position: 'absolute',
    left: 0,
    backgroundColor: 'white',
    boxShadow: '2px -2px 8px 0px rgba(218, 218, 218, 0.5)',
    width: '100%',
    height: '100%',
  }),
  variant({
    prop: 'type',
    variants: {
      full: {
        position: 'relative',
        mt: 'calc(-50vh + 45px)',
        height: '50%',
        minHeight: 'calc(100vh - 90px)',
        transition: 'top 0.5s ease',
        zIndex: 3,
      },
      // Sum of Top and Height should equal 100%
      half: {
        top: `${HALF_DRAWER_TOP}%`,
        height: `${100 - HALF_DRAWER_TOP}%`,
        transition: 'top 0.5s ease, height 0.5s ease',
        zIndex: 2,
      },
      closed: {
        display: 'none',
      },
    },
  }),
);

themeStyles.addBaseStyles('Content')(
  css({
    height: '100%',
    width: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
  }),
);

themeStyles.addBaseStyles('HandleWrapper')(
  css({
    display: 'flex',
    touchAction: 'none', // prevent the content from scrolling when listening to touch events
    pt: 'xs',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    pb: 'm',
  }),
  variant({
    prop: 'type',
    variants: {
      full: {
        position: 'sticky',
        height: '30px',
        backgroundColor: 'white',
        top: '45px',
        width: '100%',
        zIndex: 4,
      },
      half: {
        position: 'relative',
      },
    },
  }),
);

themeStyles.addBaseStyles('Handle')(
  css({
    width: '56px',
    height: '6px',
    flexShrink: 0,
    borderRadius: '100px',
    backgroundColor: 'grey.0',
  }),
);

export default themeStyles;
